export default [
  { title: 'Offers and deals', routeName: 'p2p-offers-and-deals' },

  { title: 'Roles Management', routeName: 'p2p-roles' },

  { title: 'Banners', routeName: 'p2p-banners' },
];
